
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/list",
      function () {
        return require("private-next-pages/list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/list"])
      });
    }
  